import styled from 'styled-components';

const Select = styled.select`

`;

export default Select;